module.exports = __webpack_public_path__ + "static/img/1.b601a86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/1.png
// module id = raf3
// module chunks = 0